module.exports = __webpack_public_path__ + "img/icon-heart-active.5d0733cd.svg";